<div class="cms-content">
  <marketing-template [url]="url()!" (statusChanged)="statusChanged($event)"></marketing-template>
  @if (showNotFound) {
    <u-page-not-found></u-page-not-found>
  }
</div>
